'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildQueriesForResourceFactory = exports.defaultTypes = undefined;

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _defaultTypes;

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n        query ', '($page: Int, $perPage: Int, $sortField: String, $sortOrder: String, $filter: String) {\n            ', '(page: $page, perPage: $perPage, sortField: $sortField, sortOrder: $sortOrder, filter: $filter) {\n                items { ', ' }\n                totalCount\n            }\n        }'], ['\n        query ', '($page: Int, $perPage: Int, $sortField: String, $sortOrder: String, $filter: String) {\n            ', '(page: $page, perPage: $perPage, sortField: $sortField, sortOrder: $sortOrder, filter: $filter) {\n                items { ', ' }\n                totalCount\n            }\n        }']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n        query ', '($id: ID!) {\n            ', '(id: $id) {\n                ', '\n            }\n        }'], ['\n        query ', '($id: ID!) {\n            ', '(id: $id) {\n                ', '\n            }\n        }']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n        mutation ', '($data: String!) {\n            ', '(data: $data) {\n                ', '\n            }\n        }'], ['\n        mutation ', '($data: String!) {\n            ', '(data: $data) {\n                ', '\n            }\n        }']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n        mutation ', '($id: ID!) {\n            ', '(id: $id)\n        }'], ['\n        mutation ', '($id: ID!) {\n            ', '(id: $id)\n        }']);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _constants = require('../../constants');

var _buildQuery = require('./buildQuery');

var _buildQuery2 = _interopRequireDefault(_buildQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTypes = exports.defaultTypes = (_defaultTypes = {}, (0, _defineProperty3.default)(_defaultTypes, _constants.GET_LIST, {
    name: _constants.GET_LIST,
    returnsFields: true,
    query: function query(operationName, fields) {
        return (0, _graphqlTag2.default)(_templateObject, operationName, operationName, fields);
    }
}), (0, _defineProperty3.default)(_defaultTypes, _constants.GET_ONE, {
    name: _constants.GET_ONE,
    returnsFields: true,
    query: function query(operationName, fields) {
        return (0, _graphqlTag2.default)(_templateObject2, operationName, operationName, fields);
    }
}), (0, _defineProperty3.default)(_defaultTypes, _constants.CREATE, {
    name: _constants.CREATE,
    returnsFields: true,
    query: function query(operationName, fields) {
        return (0, _graphqlTag2.default)(_templateObject3, operationName, operationName, fields);
    }
}), (0, _defineProperty3.default)(_defaultTypes, _constants.UPDATE, {
    name: _constants.UPDATE,
    returnsFields: true,
    query: function query(operationName, fields) {
        return (0, _graphqlTag2.default)(_templateObject3, operationName, operationName, fields);
    }
}), (0, _defineProperty3.default)(_defaultTypes, _constants.DELETE, {
    name: _constants.DELETE,
    returnsFields: false,
    query: function query(operationName) {
        return (0, _graphqlTag2.default)(_templateObject4, operationName, operationName);
    }
}), _defaultTypes);

var buildQueriesForResourceFactory = exports.buildQueriesForResourceFactory = function buildQueriesForResourceFactory(buildQueryImpl) {
    return function (types) {
        return function (resource, queriesAndMutations, options) {
            return Object.keys(types).reduce(function (result, type) {
                return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, type, buildQueryImpl(resource, types[type], queriesAndMutations, options)));
            }, {});
        };
    };
};

exports.default = function (resource, queriesAndMutations, options) {
    return buildQueriesForResourceFactory(_buildQuery2.default)(defaultTypes)(resource, queriesAndMutations, options);
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/buildQueriesForResource/index.js
// module id = 934
// module chunks = 0